import { IQuestion } from 'app/interfaces/IQuestion'

type QuestionWithMatrixMeta = IQuestion & { randomizeRows?: boolean }

/**
 * QuestionPropertyValidator (used by MatrixPropertyValidator) rejects undefined for
 * base IQuestion fields. MatrixPropertyValidator also assigns randomizeRows from the
 * raw question — Firebase / AI payloads may omit booleans that formatQuestion sets
 * in the builder.
 */
export function normalizeQuestionValidatorFields(question: IQuestion): void {
  const q = question as QuestionWithMatrixMeta
  q.shouldSaveInExtProfile = q.shouldSaveInExtProfile ?? false
  q.isOptional = q.isOptional ?? false
  q.positionLocked = q.positionLocked ?? false
  q.limitAnswersAmount = q.limitAnswersAmount ?? false
  q.randomizeStatements = q.randomizeStatements ?? false
  q.useUniqueMentionLabel = q.useUniqueMentionLabel ?? false
  q.maxAnswers = q.maxAnswers ?? {}
  q.minAnswers = q.minAnswers ?? {}
  q.randomizeRows = q.randomizeRows ?? false
}
